<template>
  <b-container class="pb-5">
    <b-row align-h="center">
      <b-col cols="12" md="8" lg="5">
        <div class="py-5 text-center">
          <b-img :src="require('@/assets/images/icon-aircon.svg')"></b-img>
        </div>
        <h1 class="text-center">取付依頼を承りました</h1>
        <p class="mt-5 line-height-1_7">
          のちほど弊社から日程確定またはご相談の連絡をさせていただきます。<br />
          万一2営業日以内に弊社からのご連絡がない場合、大変お手数ですが確認のご連絡をお願いいたします。<br />
          <br />
          ※繁忙期や土日などご依頼の多い日程の場合、ご希望に添えない場合がございます。
        </p>
        <p>お電話受付時間&emsp;10:00〜18:00<br />TEL: 0120-15-4147</p>
        <b-alert show variant="warning" class="mt-5">
          <ul class="pl-3 mb-0">
            <li>
              各種キャンペーン割引、工事付商品でご注文のお客様は本お申込完了後に改めてご案内致します。
            </li>
            <li>本シミュレーション結果は目安料金（消費税込み）です。</li>
            <li>
              最終確定の料金は、訪問時にご自宅環境を確認してご連絡します。
            </li>
            <li>メーカー設置基準に満たない設置は行なえません。</li>
            <li>
              環境、設置内容、機種によって、以下が発生する場合があります。
              <ol>
                <li>別途作業料の発生</li>
                <li>訪問日の調整（別日再訪問）</li>
                <li>設置のお断り</li>
              </ol>
            </li>
            <li>
              賃貸住宅や集合住宅の場合、穴あけやコンセント工事が必要な際に管理会社の許可が必要です。
            </li>
            <li>工事追加料金は、当日クレジットカード・キャッシュレス決済、または後日銀行振込（振込手数料はお客様ご負担）でのお支払いとなります。</li>
            <li>
              雨天など天候不良の場合は、日程を調整させて頂く場合があります。
            </li>
          </ul>
        </b-alert>
        <div class="text-center mt-5">
          <b-button variant="primary" size="lg" href="https://aircon-hanbai.jp/"
            >TOPへ</b-button
          >
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
    
<script>
import { mapState } from "vuex";

export default {
  mounted() {
    // シミュレーション結果が無い場合はトップページへリダイレクト
    if (!this.zip) {
      this.$router.push({ name: "page1" });
    }
  },
  computed: {
    ...mapState({
      zip() {
        return this.$store.getters.zip;
      },
    }),
  },
};
</script>